import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ChipSelect, { ChipSelectProps } from '@/components/fields/ChipSelect';
import { useOffices } from '@/hooks/useOffices';

type OfficeChipSelectProps = Omit<ChipSelectProps, 'options'>;

const OfficeChipSelect: FC<OfficeChipSelectProps> = props => {
  const { officesOptions } = useOffices();
  const { t } = useTranslation('filters');

  const officeOptions = useMemo(
    () => [
      { value: null as unknown as string, label: t('filters.options.offices.all') },
      ...officesOptions.map(({ id, label }) => ({ value: id, label }))
    ],
    [officesOptions, t]
  );

  return <ChipSelect {...props} options={officeOptions} />;
};

export default OfficeChipSelect;
